<template>
    <div
        class="bg-gray-100 border border-gray-200 rounded-sm text-gray-700 p-1 w-full h-full flex flex-col items-center"
    >
        <div class="text-sm/none font-semibold mb-0.5">
            <slot name="header" />
        </div>

        <slot name="content" />
    </div>
</template>
